import { GlobalStyles } from "@chakra-ui/theme-tools";
import { MaybernTableAgTheme } from "shared/components/table/maybern/MaybernTableAgTheme";

export const styles: GlobalStyles = {
  global: {
    ...MaybernTableAgTheme,
    ".chakra-stat__group": {
      "&&": {
        justifyContent: "flex-start",
      },
      gap: "24px",
    },
    ".chakra-table__container .chakra-stat__group": {
      bg: "none",
      borderRadius: 0,
      borderWidth: "0 0 1px 0",
      boxShadow: "none",
      px: 2,
    },
    ".mb-tablebox-focus-lock[data-focus-lock-disabled=disabled]": {
      display: "contents",
    },
    ":root": {
      "--mb-tablebox-header-height": "48px",
    },
    body: {
      "&&": {
        textStyle: "body",
      },
      backgroundColor: "unset",
      textStyle: "body",
    },
    // Hides the Edge browser native password reveal button, we use our own
    "::-ms-reveal": {
      display: "none",
    },
  },
};
